import SliderTypeIcon from './SliderTypeIcon';
export default SliderTypeIcon;
